import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "../lib/constants";

const BG = "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=2400&q=80";

export default function FinalCTA() {
    return (
        <section className="relative bg-brand-ink text-white overflow-hidden" data-testid="final-cta-section">
            <div className="absolute inset-0 opacity-30">
                <img src={BG} alt="Luxury home backdrop" className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/85 to-brand-ink/60" />
            </div>
            <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#FF8800] opacity-25 blur-[140px] pointer-events-none" />
            <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#CB1010] opacity-20 blur-[140px] pointer-events-none" />

            <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 py-24 md:py-36">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                    className="max-w-4xl"
                >
                    <div className="inline-flex items-center gap-3 mb-7">
                        <span className="w-8 h-px bg-[#FF8800]" />
                        <span className="text-[10px] uppercase tracking-[0.25em] text-[#FF8800] font-medium">Begin your journey</span>
                    </div>

                    <h2
                        className="font-display font-semibold text-white text-[clamp(2rem,5.5vw,4.5rem)] leading-[1.02] tracking-[-0.035em]"
                        data-testid="final-cta-heading"
                    >
                        Let's build your{" "}
                        <span className="font-serif-italic font-normal brand-gradient-text">legacy</span>
                        <br />
                        together.
                    </h2>

                    <p className="mt-7 text-white/70 text-base md:text-lg max-w-2xl leading-relaxed">
                        From your first blueprint to your final housewarming celebration —
                        Dhanshree Constructions is with you at every step of the way.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
                        <a
                            href={BRAND.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center justify-between gap-5 brand-gradient text-white pl-7 pr-2 py-2 rounded-full font-medium text-[15px] hover:opacity-95 transition self-start"
                            data-testid="final-cta-button"
                        >
                            <span>Start your dream home</span>
                            <span className="w-11 h-11 rounded-full bg-white text-brand-ink flex items-center justify-center group-hover:rotate-45 transition-transform duration-300">
                                <ArrowUpRight size={18} strokeWidth={2.4} />
                            </span>
                        </a>
                        <div className="flex flex-col gap-0.5 sm:ml-4">
                            <span className="text-[10px] uppercase tracking-[0.2em] text-white/50">Or call directly</span>
                            <a href={`tel:${BRAND.phoneRaw}`} className="font-display font-semibold text-xl text-white">
                                {BRAND.phone}
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
